(function () {
  var PAD = 12;
  var RIGHT_PAD = 88;
  var ITEM_SELECTOR = '[data-navmenu-meganav-type="meganav-category-products"]';
  var MENU_SELECTOR = '.navmenu-meganav--category-products';

  function align(item) {
    var submenu = item.querySelector(MENU_SELECTOR);
    if (!submenu || window.matchMedia('(max-width: 1023px)').matches) return;

    var alignRight = submenu.getAttribute('data-dropdown-align') === 'right';

    submenu.style.left = '';
    submenu.style.right = '';

    if (alignRight) {
      submenu.style.left = 'auto';
      submenu.style.right = '0px';
    } else {
      submenu.style.left = '0px';
      submenu.style.right = 'auto';
    }

    var rect = submenu.getBoundingClientRect();
    if (!rect.width) return;

    var viewport = document.documentElement.clientWidth;
    var shift = 0;

    if (rect.right > viewport - RIGHT_PAD) {
      shift = viewport - RIGHT_PAD - rect.right;
    }

    if (rect.left + shift < PAD) {
      shift = PAD - rect.left;
    }

    if (alignRight) {
      submenu.style.right = -shift + 'px';
    } else {
      submenu.style.left = shift + 'px';
    }
  }

  function bind(item) {
    if (item.dataset.megaMenuBound === 'true') return;
    item.dataset.megaMenuBound = 'true';

    var submenu = item.querySelector(MENU_SELECTOR);
    if (!submenu) return;

    var observer = new MutationObserver(function () {
      requestAnimationFrame(function () {
        align(item);
      });
    });

    observer.observe(submenu, {
      attributes: true,
      attributeFilter: ['data-animation-state', 'data-animation']
    });

    item.addEventListener('mouseenter', function () {
      requestAnimationFrame(function () {
        align(item);
      });
    });
  }

  function init() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.addEventListener('resize', function () {
    document.querySelectorAll(ITEM_SELECTOR).forEach(align);
  });
})();
